import * as yup from 'yup';

import {
  clientSchema,
  NO_SALUTATION_SELECTED,
} from '@/features/Clients/Schemas/Base';
import { locales } from '@/features/validation/locales';
import { isValidPhoneNumber } from '@/utils/phone/phone';
import { testSpecialChars } from '@/utils/strings/strings';
import { useGlobalStore } from '@/features/Global/store';

yup.setLocale(locales);

export const VersicherungsnehmerContractBaseSchema = clientSchema.concat(
  yup.object({
    vorname: yup.string().required().test(testSpecialChars),
    nachname: yup.string().required().test(testSpecialChars),
    geburtsdatum: yup.date().required(),
  }),
);

export const VersicherungsnehmerCompanyContractBaseSchema = clientSchema.concat(
  yup.object({
    nachname: yup.string().required().test(testSpecialChars),
  }),
);

export const VersicherungsnehmerPropertyContractSchema =
  VersicherungsnehmerContractBaseSchema.concat(
    yup.object().shape(
      {
        anredeId: yup.number().required().notOneOf([NO_SALUTATION_SELECTED]),

        adresse: yup.object({
          strasse: yup.string().required().test(testSpecialChars),
          hausnummer: yup.string().required().test(testSpecialChars),
          plz: yup.string().required().test(testSpecialChars),
          ort: yup.string().required().test(testSpecialChars),
        }),

        email: yup.string().email().required().test(testSpecialChars),
        beruf: yup
          .string()
          .when({
            is: () => useGlobalStore().sparte !== 'unf',
            then: yup.string().required(),
          })
          .test(testSpecialChars),
        telefon: yup
          .string()
          .when('mobil', {
            is: (val: string) => val === '',
            then: yup.string().required(),
          })
          .test({
            name: 'isValid',
            message: 'Das Format ist nicht gültig.',
            test(val) {
              if (val === undefined || val === '') {
                return true;
              }

              return isValidPhoneNumber(val);
            },
          })
          .test(testSpecialChars),
        mobil: yup
          .string()
          .when('telefon', {
            is: (val: string) => val === '',
            then: yup.string().required(),
          })
          .test({
            name: 'isValid',
            message: 'Das Format ist nicht gültig.',
            test(val) {
              if (val === undefined || val === '') {
                return true;
              }

              return isValidPhoneNumber(val);
            },
          })
          .test(testSpecialChars),
        familienstand: yup.string().required(),
      },
      [['telefon', 'mobil']],
    ),
  );

export const VersicherungsnehmerCompanyPropertyContractSchema =
  clientSchema.concat(
    yup.object().shape(
      {
        nachname: yup.string().required().test(testSpecialChars),

        adresse: yup.object({
          strasse: yup.string().required().test(testSpecialChars),
          hausnummer: yup.string().required().test(testSpecialChars),
          plz: yup.string().required().test(testSpecialChars),
          ort: yup.string().required().test(testSpecialChars),
        }),

        email: yup.string().email().required().test(testSpecialChars),
        telefon: yup
          .string()
          .when('mobil', {
            is: (val: string) => val === '',
            then: yup.string().required(),
          })
          .test({
            name: 'isValid',
            message: 'Das Format ist nicht gültig.',
            test(val) {
              if (val === undefined || val === '') {
                return true;
              }

              return isValidPhoneNumber(val);
            },
          })
          .test(testSpecialChars),
        mobil: yup
          .string()
          .when('telefon', {
            is: (val: string) => val === '',
            then: yup.string().required(),
          })
          .test({
            name: 'isValid',
            message: 'Das Format ist nicht gültig.',
            test(val) {
              if (val === undefined || val === '') {
                return true;
              }

              return isValidPhoneNumber(val);
            },
          })
          .test(testSpecialChars),
      },
      [['telefon', 'mobil']],
    ),
  );
